jQuery(document).ready(function ($) {

    $('.js-next-section').on('click', function (event) {
        event.preventDefault();

        const $nextSection = $(this).closest('section').nextAll('section').first();

        if (!$nextSection.length) {
            return;
        }

        $('html, body').animate({
            scrollTop: $nextSection.offset().top
        }, 800);
    });

});
